export default __webpack_public_path__ + "static/media/dc.d899eddc.jpg";